// extracted by mini-css-extract-plugin
export var animating = "_40-3";
export var background = "_40-6";
export var constrainHeight = "_40-2";
export var dark = "_40-4";
export var dropdown = "_40-1";
export var leave = "_40-5";
export var option = "_40-7";
export var root = "_40-0";